<template>
  <div class="mask">
    <div class="tip_modal">
      <div class="warntitle"><img class="warnimg" :src="require('../../../../assets/appraise/msg_title.png')" />{{ title }}</div>
      <div class="cont-warn">{{content}}</div>
      <div class="bot" @click="close">我知道了</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: () => {
        return "请选择格式为PDF的附件";
      }
    },
    title:{
        type: String,
        default: ()=>{
            return '格式错误'
        }
    }
  },
  methods: {
    close() {
      this.$emit('closeModal')
    }
  }
};
</script>

<style scoped lang="less">
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, .3);
  }
  .tip_modal {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 260px;
    height: 153px;
    border-radius: 4px;
    background-color: #fff;
    .warntitle{    
        margin-bottom: 12px;
        font-size: 18px;
        color: #333;
        font-weight: bold;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 28px;
        margin-bottom: 12px;
        .warnimg{
            width: 14px;
            height: 14px;
            margin-right: 4px;
        }
    }
    .cont-warn { 
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 22px;
        text-align: center;
    }
    .bot {
      width: 100%;
      height: 47px;
      line-height: 47px;
      font-size: 16px;
      color: #36B374;
      border-top: 1px solid #E5E5E5;
      text-align: center;
      position: absolute;
      bottom: 0;
    }
  }
</style>
